module.exports = __webpack_public_path__ + "img/x-man.8d7bec39.png";